<!-- Header -->
<h3 mat-dialog-title
	translate>
	No Categories Defined
</h3>

<!-- Body -->
<mat-dialog-content>
	<span translate>
		Data Definitions for Student Note Categories have not been defined.
	</span>
	<br />
	<span translate>
		These are needed in order to use the Student Notes option.
	</span>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button image="Cancel.png"
			label="Close"
			(clickEvent)="close()"></tyl-button>
	</div>
</mat-dialog-actions>